import { render, staticRenderFns } from "./importExport.vue?vue&type=template&id=bc482b60&scoped=true&"
import script from "./importExport.vue?vue&type=script&lang=js&"
export * from "./importExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc482b60",
  null
  
)

export default component.exports